<template>
  <Modal v-model="visible" :title="title" :footer-hide="true" :mask-closable="false" width="600" class="my-modal min">
    <Form class="page-form" ref="form" :model="formInline" :rules="ruleInline" :label-width="100">
      <FormItem prop="addCode" label="主险产品" class="full">
        <Select v-model="formInline.addCode" clearable filterable :label-in-value="true" @on-select="selectItem">
          <Option v-for="(item, i) in productList" :key="i" :value="item.productCode">{{ item.productCode }}/{{ item.productName }} </Option>
        </Select>
      </FormItem>
    </Form>
    <div class="ivu-modal-footer">
      <Button type="text" @click="visible = false">取消</Button>
      <Button type="primary" @click="confirmAdd" :loading="loading">提交</Button>
    </div>
  </Modal>
</template>

<script>
export default {
  mixins: [],
  components: {},
  props: ['productList', 'additionals', 'productCode'],
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入附加险code'));
      } else {
        if (this.additionals && this.additionals.length) {
          let lth = this.additionals.filter(i => i.addCode == this.formInline.addCode).length;
          let idx = this.additionals.findIndex(i => i.addCode == this.formInline.addCode);
          if (
            (this.editType == 1 && lth != 0) ||
            (this.editType == 2 && (lth > 1 || (idx != -1 && idx != this.selIndex))) ||
            (this.productCode && this.formInline.addCode == this.productCode.trim())
          ) {
            callback('产品code已存在，请重新录入');
          }
          callback();
        }
        callback();
      }
    };
    return {
      title: '',
      formInline: {
        addCode: '',
        type: '2' //附加险类型（1、附加险 2、主险关联）
      },
      visible: false,
      loading: false,
      selPro: {},
      selIndex: '',
      ruleInline: {
        addCode: [
          {
            required: true,
            message: '请选择'
          },
          { validator: validatePass, trigger: 'change' }
        ]
      }
    };
  },
  watch: {
    visible(newVal) {
      if (!newVal) {
        this.$refs.form.resetFields();
      }
    }
  },
  methods: {
    selectItem(item) {
      this.selPro = this.productList.find(i => i.productCode == item.value);
    },
    open(row = {}, editType, index = null) {
      this.loading = false;
      this.title = editType == 1 ? '新增主险' : '编辑主险';
      this.visible = true;
      this.selPro = {};
      this.editType = editType; //1新增  2修改
      this.selIndex = index;
      let data = JSON.parse(JSON.stringify(row));
      if (data.addCode) {
        this.formInline = data;
      }
    },
    confirmAdd() {
      this.loading = true;
      //新增附加险
      this.$refs.form.validate().then(isok => {
        if (!isok) {
          this.loading = false;
          return;
        }
        if (isok) {
          this.$emit(
            'success',
            this.editType,
            {
              ...this.formInline,
              addName: this.selPro.productName
            },
            this.selIndex
          );
          this.visible = false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.my-modal {
  /deep/ {
    .ivu-checkbox-inner {
      top: -1px;
    }

    .ivu-checkbox-group-item {
      width: 25%;
      margin-right: 0;
    }
  }
}

.tab-box {
  position: relative;
  margin-bottom: 10px;

  .tab-name {
    position: absolute;
    left: 0;
    top: 11px;
    z-index: 1;
    font-size: 14px;
    font-weight: bold;
  }

  /deep/ {
    .ivu-tabs-nav {
      padding-left: 120px;
    }
  }
}
</style>
